import React from 'react'
import { withRouter } from 'react-router-dom'
import { Container } from '../../components_renew/Layout'
import { Card } from 'antd-mobile'

@withRouter
class MessageText extends React.PureComponent {
  constructor (props) {
    super(props)
    document.title = '消息详情';
    this.message = localStorage.getItem('message')
    this.title = localStorage.getItem('title')
  }

  render () {
    // return <div style={style.page}>
    //   <p style={style.nav}>
    //     <span>{this.title}</span>
    //   </p>
    //   <p style={style.text}>{this.message}</p>
    // </div>
    return <Container>
      <div style={{ margin: '2rem 1rem' }}>
        <Card title={this.title}>
          {this.message}
        </Card>
      </div>
    </Container>
  }

}

export default MessageText
